import { render } from "./EncabezadoLogosComponent.vue?vue&type=template&id=a79dc6e2&scoped=true"
const script = {}

import "./EncabezadoLogosComponent.vue?vue&type=style&index=0&id=a79dc6e2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79dc6e2"]])

export default __exports__